export default "__VITE_ASSET__8c496790__"